import(/* webpackMode: "eager" */ "/workspace/app/resources/lmn/page.tsx");
